export const getSpecialShift = (
  memberId,
  date,
  startDate,
  endDate,
  squadId,
  forbiddenCertificates,
  memberShouldBeActive = false,
  desiredChannels = [],
  desiredProfiles = [],
  limit = '',
  offset = ''
) => {
  return `
    SELECT
      Id,
      X0h00m_0h30m__c,
      X0h30m_1h00m__c,
      X1h00m_1h30m__c,
      X1h30m_2h00m__c,
      X2h00m_2h30m__c,
      X2h30m_3h00m__c,
      X3h00m_3h30m__c,
      X3h30m_4h00m__c,
      X4h00m_4h30m__c,
      X4h30m_5h00m__c,
      X5h00m_5h30m__c,
      X5h30m_6h00m__c,
      X6h00m_6h30m__c,
      X6h30m_7h00m__c,
      X7h00m_7h30m__c,
      X7h30m_8h00m__c,
      X8h00m_8h30m__c,
      X8h30m_9h00m__c,
      X9h00m_9h30m__c,
      X9h30m_10h00m__c,
      X10h00m_10h30m__c,
      X10h30m_11h00m__c,
      X11h00m_11h30m__c,
      X11h30m_12h00m__c,
      X12h00m_12h30m__c,
      X12h30m_13h00m__c,
      X13h00m_13h30m__c,
      X13h30m_14h00m__c,
      X14h00m_14h30m__c,
      X14h30m_15h00m__c,
      X15h00m_15h30m__c,
      X15h30m_16h00m__c,
      X16h00m_16h30m__c,
      X16h30m_17h00m__c,
      X17h00m_17h30m__c,
      X17h30m_18h00m__c,
      X18h00m_18h30m__c,
      X18h30m_19h00m__c,
      X19h00m_19h30m__c,
      X19h30m_20h00m__c,
      X20h00m_20h30m__c,
      X20h30m_21h00m__c,
      X21h00m_21h30m__c,
      X21h30m_22h00m__c,
      X22h00m_22h30m__c,
      X22h30m_23h00m__c,
      X23h00m_23h30m__c,
      X23h30m_0h00m__c,
      Atestado__c,
      Canal_de_Atendimento__c,
      Data_trabalhada__c,
      Justificativa_treinamento__c,
      Dia__c,
      Justificativa__c,
      Membro__c,
      Membro__r.Nome_do_outlook__c,
      Membro__r.data_de_contratacao__c,
      Membro__r.tipo_de_contratacao__c,
      Membro__r.canal_de_atendimento__c,
      Membro__r.Status__c,
      Membro__r.Mesa_Opera_o__r.Name,
      Name,
      Tipo__c,
      Canal_da_Escala__c,
      Time_da_Escala__c,
      Suporte_Absenteismo__c
    FROM
      Horario_Especial__c
    WHERE
      Dia__c != null
      ${memberId ? `AND Membro__c = '${memberId}'` : ''}
      ${date ? `AND Dia__c = ${date}` : ''}
      ${startDate ? `AND Dia__c >= ${startDate}` : ''}
      ${endDate ? `AND Dia__c <= ${endDate}` : ''}
      ${squadId ? `AND Membro__r.Mesa_Opera_o__c = '${squadId}'` : ''}
      ${
        forbiddenCertificates && Array.isArray(forbiddenCertificates)
          ? forbiddenCertificates
              .map(fCertificate => {
                return `
      AND Atestado__c <> '${fCertificate}'`;
              })
              .join(' ')
          : ''
      }
      ${memberShouldBeActive ? `AND Membro__r.Name__r.IsActive = true` : ''}
      ${
        desiredChannels && Array.isArray(desiredChannels) && desiredChannels.length > 1
          ? `
      AND Membro__r.canal_de_atendimento__c IN (${desiredChannels
        .map(profile => `'${profile.replace("'", '')}'`)
        .join(', ')})`
          : desiredChannels && Array.isArray(desiredChannels) && desiredChannels.length
          ? `
      AND Membro__r.canal_de_atendimento__c = '${desiredChannels[0]}'`
          : ''
      }
      ${
        desiredProfiles && Array.isArray(desiredProfiles) && desiredProfiles.length
          ? `
      AND (
        ${desiredProfiles
          .map(profile => {
            return `
        Membro__r.Time__c = '${profile}'`;
          })
          .join(' OR')}
      )`
          : ''
      }
    ${limit ? `LIMIT ${limit}` : ''}
    ${offset ? `OFFSET ${offset}` : ''}
  `
    .trim() // removes leading and trailing spaces and blank lines
    .replace(/^\s*$(?:\r\n?|\n)/gm, '');
};
